export default "__VITE_ASSET__HaI2950s__"